export default function manageParams() {
    const params = new URLSearchParams(window.location.search);

    const forecast = params.get('forecast') || 'D1';
    const app = params.get('app');
    const scale = params.get('scale');
    const lat = params.get('lat');
    const lng = params.get('lng');
    const zoom = params.get('zoom');
    
    return { forecast, app, scale, lat, lng, zoom };
}